module.exports = __webpack_public_path__ + "static/media/home_9.f7a19772.jpg";